import Vue from 'vue';
import Vuex from 'vuex';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';

import { auth } from './auth.module';
import { bytepro } from './bytepro.module';
import { price } from './price.module';
import { resource } from './resources.module';
import { defaultSetting } from './defaultsetting.module';
import { lockDesk } from './lockDesk.module';
import { doc } from './doc.module';
import { security } from './security.module';
import { investorFee } from './investorFee.module';
import { warehouse } from './warehouse.module';
import { statusDialog } from './statusDialog.module';
import { statusSnackbar } from './statusSnackbar.module';

import { accounting } from './feature/accounting.module';
import { disclosure } from './feature/disclosure.module';
import { docuSign } from './feature/docuSign.module';
import { logApiCallApi } from './feature/logApiCall.module';
import { lookUpApi } from './feature/lookUp.module';
import { authApi } from './feature/auth.module';

import { mstCodeApi } from './nwapp/mstCode.module';
import { priceApi } from './nwapp/price.module';

import { fileDataApi } from './bytepro/filedata.module';
import { statusApi } from './bytepro/status.module';
import { secondaryApi } from './bytepro/secondary.module';
import { embeddedDoc } from './bytepro/embeddedDoc.module';
import { docSigner } from './bytepro/docSigner.module';
import { docPackage } from './bytepro/docPackage.module';
import { disclosureLogEntry } from './bytepro/disclosureLogEntry.module';
import { printSet } from './bytepro/printSet.module';
import { printSetItem } from './bytepro/printSetItem.module';
import { documentProperty } from './bytepro/documentProperty.module';
import { userOrgProfileApi } from './bytepro/userOrgProfile.module';
import { organizationApi } from './bytepro/organization.module';
import { orgCompPlanApi } from './bytepro/orgCompPlan.module';
import { compPlanApi } from './bytepro/compPlan.module';
import { securityProfileApi } from './bytepro/securityProfile.module';
// import { documentCategoryApi } from "./bytepro/documentCategory.module";
import { documentTypeApi } from './bytepro/documentType.module';
import { customFieldsApi } from './bytepro/customFields.module';
import { transmittalApi } from './bytepro/transmittal.module';
import { loanApi } from './bytepro/loan.module';
import { partyMiscApi } from './bytepro/partyMisc.module';
import { extendedFieldsApi } from './bytepro/extendedFields.module';
import { userApi } from './bytepro/user.module';

import { investorApiV2 } from './v2/bytepro/investor.module';
import { loanPaymentApi } from './v2/bytepro/loanPayment.module';
import { embeddedDocApi } from './v2/bytepro/embeddedDoc.module';
import { documentCategoryApi } from './v2/bytepro/documentCategory.module';

import { loanPaymentInformationApi } from './v2/nwapp/loanPaymentInformation.module';

import { featuresApi } from './v2/common/features.module';
import { securityApi } from './v2/common/security.module';

import { bankStatementAIApi } from './v2/common/bankStatementAI.module';
import { announcementApi } from './v2/common/announcement.module';
import { commonApi } from './v2/intranet/common.module';
import { lockDesk as lockDeskV2 } from './v2/pricingEngine/lockDesk.module';

import AnalyticsService from '../services/analytics.service';
import LogService from '../services/log.service';
import NotificationService from '../services/notification.service';

Vue.use(Vuex);

export default new Vuex.Store({
  // Global variable
  namespace: true,
  state: {
    drawer: true,
    pageDisabled: false,
    pdfDialog: {
      show: false,
      src: null,
    },
    mask: {
      currency: createNumberMask({
        prefix: '',
        allowDecimal: true,
        allowNegative: true,
      }),
      percent: createNumberMask({
        prefix: '',
        allowDecimal: true,
        allowNegative: true,
        integerLimit: 3,
        decimalLimit: 3,
        maxValue: 100,
        minValue: -100,
      }),
      percent2: createNumberMask({
        prefix: '',
        allowDecimal: true,
        allowNegative: true,
        integerLimit: 2,
        decimalLimit: 2,
        maxValue: 100,
        minValue: -100,
      }),
      point: createNumberMask({
        prefix: '',
        allowDecimal: true,
        allowNegative: true,
        integerLimit: 2,
        decimalLimit: 3,
        maxValue: 100,
        minValue: -100,
        requireDecimal: true,
      }),
      point8: createNumberMask({
        prefix: '',
        allowDecimal: true,
        allowNegative: true,
        integerLimit: 2,
        decimalLimit: 8,
        maxValue: 100,
        minValue: -100,
      }),
      creditScore: '###',
      phone: '(###) ###-####',
      ssn: '###-##-####',
      date: '##/##/####',
      date2: '####-##-##',
      datetime: '##/##/#### ##:##',
      creditCard: {
        cardNumber: '#### #### #### ####',
        expiration: '##/##',
        ccv: '####',
      },
    },
    mstCodeEnums: [],
    colors: ['primary', 'secondary', 'success', 'warning', 'error'],
    appSettings: {
      company: {
        shortName: 'New Wave Lending',
        name: 'New Wave Lending Group Inc.',
        street1: '1199 FAIRWAY DR',
        street2: '',
        city: 'CITY OF INDUSTRY',
        state: 'CA',
        zip: '91789',
        phone: '(626) 820-9081',
        email: 'info@newwavelending.com',
        nmls: '1649874',
      },
      security: {
        key: 'new-wave-key-11092020',
      },
      // darkMode: (VueCookies.get("theme:dark") ?? "false") == "true",
    },
  },
  getters: {
    DRAWER_STATE(state) {
      return state.drawer;
    },
    color: (state) => (index) => {
      return state.colors[index % state.colors.length];
    },
    mstCodeEnums(state) {
      return state.mstCodeEnums;
    },
    getMstCodeEnum: (state) => (key) => {
      return state.mstCodeEnums[key] || '';
    },
  },
  mutations: {
    setPageDisabled(state, isDisabled) {
      state.pageDisabled = isDisabled;
    },
    toggleDrawer(state) {
      state.drawer = !state.drawer;
    },
    showPdfDialog(state, src) {
      state.pdfDialog.src = src;
      state.pdfDialog.show = true;
    },
    closePdfDialog(state) {
      state.pdfDialog.show = false;
      state.pdfDialog.src = null;
    },
    setMstCodeEnums(state, mstCodeEnums) {
      state.mstCodeEnums = mstCodeEnums;
    },
    dummy() {},
    successConsole() {
      console.log('Request success');
    },
    errorConsole(state, message) {
      console.log(`Failure: ${message}`);
    },
  },
  actions: {
    toggleDrawer({ commit }) {
      commit('toggleDrawer');
    },
    sendEmail({ commit }, emailModel) {
      return NotificationService.sendEmail(emailModel).then(
        (resp) => {
          commit('successConsole');
          return Promise.resolve(resp);
        },
        (error) => {
          commit(
            'errorConsole',
            (error.response && error.response.data) || error.message || error.toString()
          );
          return Promise.reject(
            (error.response && error.response.data) || error.message || error.toString()
          );
        }
      );
    },
    resendEmail({ commit }) {
      return NotificationService.resendEmail().then(
        (resp) => {
          commit('dummy');
          return Promise.resolve(resp);
        },
        (error) => {
          commit('dummy');
          return Promise.reject(
            (error.response && error.response.data) || error.message || error.toString()
          );
        }
      );
    },
    getEmailTemplate({ commit }, model) {
      return NotificationService.getEmailTemplate(model.loanNumber, model.notificationType).then(
        (resp) => {
          commit('dummy');
          return Promise.resolve(resp);
        },
        (error) => {
          commit('dummy');
          return Promise.reject(
            (error.response && error.response.data) || error.message || error.toString()
          );
        }
      );
    },
    getLogEmailSubmission({ commit }, loanNumber) {
      return LogService.getEmailSubmission(loanNumber).then(
        (resp) => {
          commit('dummy');
          return Promise.resolve(resp);
        },
        (error) => {
          commit('dummy');
          return Promise.reject(
            (error.response && error.response.data) || error.message || error.toString()
          );
        }
      );
    },
    getOrganizations({ commit }) {
      return AnalyticsService.getOrganizations().then(
        (resp) => {
          commit('successConsole');
          return Promise.resolve(resp);
        },
        (error) => {
          commit(
            'errorConsole',
            (error.response && error.response.data) || error.message || error.toString()
          );
          return Promise.reject(
            (error.response && error.response.data) || error.message || error.toString()
          );
        }
      );
    },
    getRegisteredLoan({ commit }, organizationId) {
      return AnalyticsService.getRegisteredLoan(organizationId).then(
        (resp) => {
          commit('successConsole');
          return Promise.resolve(resp);
        },
        (error) => {
          commit(
            'errorConsole',
            (error.response && error.response.data) || error.message || error.toString()
          );
          return Promise.reject(
            (error.response && error.response.data) || error.message || error.toString()
          );
        }
      );
    },
  },
  modules: {
    auth,
    bytepro,
    price,
    resource,
    defaultSetting,
    lockDesk,
    lockDeskV2,
    disclosure,
    doc,
    documentCategoryApi,
    documentTypeApi,
    customFieldsApi,
    security,
    securityApi,
    investorFee,
    warehouse,
    statusDialog,
    statusSnackbar,
    fileDataApi,
    embeddedDoc,
    docSigner,
    docPackage,
    disclosureLogEntry,
    printSet,
    printSetItem,
    documentProperty,
    orgCompPlanApi,
    compPlanApi,
    organizationApi,
    userOrgProfileApi,
    securityProfileApi,
    authApi,
    accounting,
    docuSign,
    logApiCallApi,
    lookUpApi,
    statusApi,
    secondaryApi,
    mstCodeApi,
    priceApi,
    transmittalApi,
    loanApi,
    partyMiscApi,
    extendedFieldsApi,
    userApi,
    featuresApi,
    loanPaymentApi,
    loanPaymentInformationApi,
    investorApiV2,
    embeddedDocApi,
    bankStatementAIApi,
    announcementApi,
    commonApi,
  },
});
